__webpack_require__.p = "/edu/";